import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;

    .govBar {
      width: 100%;
      padding: ${theme.spacings[4]} ${theme.spacings[64]};

      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.spacings[4]} ${theme.spacings[24]};

      background: linear-gradient(to right, #295585, #23669f);

      .links {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: ${theme.spacings[4]} ${theme.spacings[12]};
      }

      .link {
        font-size: ${theme.font.sizes.xs};

        color: ${theme.colors.white};

        &:hover {
          text-decoration: underline;
        }
      }

      .dropdownLinks {
        display: none;
      }

      @media (max-width: 1000px) {
        padding: ${theme.spacings[4]} ${theme.spacings[32]};
      }

      @media (max-width: 600px) {
        justify-content: center;
      }
    }
  `}
`;

export const Header = styled.header`
  ${({ theme }) => css`
    width: 100%;
    padding: ${theme.spacings[4]} ${theme.spacings[32]} ${theme.spacings[4]} ${theme.spacings[32]};

    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${theme.colors.white};

    > a {
      display: inline-flex;
    }

    .sgbLogo,
    .sgbLogoEnUs {
      width: 12rem;
    }

    .P3MlogoBlock {
      width: 30rem;
    }

    .P3MlogoSmallBlock {
      display: none;
      margin-left: auto;
    }

    .versionLogo {
      display: flex;
      align-items: center;
      margin-left: 220px;

      p {
        background: ${theme.colors.blue600};
        color: white;
        border: 5px solid ${theme.colors.blue600};
        border-radius: 10px 30px;
        font-size: 12px;
      }
    }

    .versionBeta {
      p {
        background: #696969;
        color: white;
        border: 5px solid #696969;
        border-radius: 10px 30px;
        font-size: 12px;
      }
    }

    .linksBlock {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      a,
      button {
        font-family: ${theme.font.family.default};
        font-size: ${theme.font.sizes.md};

        display: flex;
        align-items: center;

        border: 0;

        background-color: transparent;
        color: ${theme.colors.indigo800};
        font-weight: ${theme.font.weights.medium};

        &:hover {
          text-decoration: underline;
        }
      }

      a + a {
        margin-left: ${theme.spacings[20]};
      }
    }

    #contactButton {
      color: ${theme.colors.indigo800};
      font-weight: ${theme.font.weights.medium};
      font-size: ${theme.font.sizes.sm};
      right: 20px;
      gap: ${theme.spacings[8]};
    }

    @media (max-width: 1000px) {
      padding: ${theme.spacings[4]} ${theme.spacings[16]} ${theme.spacings[4]} 0;
    }

    @media (max-width: 900px) {
      .versionLogo {
        margin-right: 0px;
        margin-left: -55px;
      }
    }

    @media (max-width: 730px) {
      #contactLabel {
        display: none;
      }
    }

    @media (max-width: 640px) {
      padding-left: 0;
      padding-right: 0;

      .versionLogo {
        justify-content: center;
      }

      .P3MlogoBlock {
        display: none;
      }

      .P3MlogoSmallBlock {
        margin-right: 10px;
        width: 9rem;
        display: block;
      }

      .sgbLogo,
      .sgbLogoEnUs {
        width: 13rem;
      }

      #contactButton {
        margin-right: 10px;
      }
    }

    @media (max-width: 400px) {
      .P3MlogoBlock {
        display: none;
      }

      .P3MlogoSmallBlock {
        display: block;
        width: 8rem;
        margin-left: 20px;
      }

      .sgbLogo,
      .sgbLogoEnUs {
        width: 12rem;
      }

      #contactLabel {
        font-size: ${theme.font.sizes.xs};
      }
    }

    @media (max-width: 300px) {
      .P3MlogoSmallBlock {
        margin-right: 0px;
      }
    }
  `}
`;

export const UserDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-left: ${({ theme }) => theme.spacings[20]};
`;

export const UserDropdownToggle = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  outline: none;
  transition: transform 0.2s ease;

  &:focus-visible {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.blue600}88;
  }
`;

export const UserAvatar = styled.img`
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid ${({ theme }) => theme.colors.blue600 ?? '#23669f'};
  cursor: pointer;
  flex-shrink: 0;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.blue600 ?? '#23669f'}44;
    transform: scale(1.05);
  }
`;

export const UserInitials = styled.div`
  ${({ theme }) => css`
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    background: ${theme.colors.blue600 ?? '#23669f'};
    color: white;
    font-size: ${theme.font.sizes.md};
    font-weight: ${theme.font.weights.bold};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    border: 2px solid ${theme.colors.blue600 ?? '#23669f'};
    transition: box-shadow 0.2s ease, transform 0.2s ease;

    &:hover {
      box-shadow: 0 0 0 3px ${theme.colors.blue600 ?? '#23669f'}44;
      transform: scale(1.05);
    }
  `}
`;

export const AnonymousAvatar = styled.div`
  ${({ theme }) => css`
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    background: ${theme.colors.blue600 ?? '#23669f'};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    border: 2px solid ${theme.colors.blue600 ?? '#23669f'};
    transition: box-shadow 0.2s ease, transform 0.2s ease;

    svg {
      font-size: 1.8rem;
    }

    &:hover {
      box-shadow: 0 0 0 3px ${theme.colors.blue600 ?? '#23669f'}44;
      transform: scale(1.05);
    }
  `}
`;

export const UserDropdownMenu = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: ${theme.colors.white};
    border-radius: ${theme.radius.xs ?? '0.8rem'};
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 3px 10px rgba(0, 0, 0, 0.05);
    border: 1px solid ${theme.colors.gray200};
    min-width: 20rem;
    padding: ${theme.spacings[8]} 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    
    /* Animation */
    animation: fadeIn 0.15s ease-out;
    
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(-8px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `}
`;

export const UserMenuHeader = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings[12]} ${theme.spacings[16]};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[2]};
    cursor: default;
    
    .user-name {
      font-family: ${theme.font.family.default};
      font-size: ${theme.font.sizes.sm};
      font-weight: ${theme.font.weights.bold};
      color: ${theme.colors.indigo800};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .user-email {
      font-family: ${theme.font.family.default};
      font-size: ${theme.font.sizes.xs};
      color: ${theme.colors.gray600};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `}
`;

export const UserMenuDivider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray200};
  margin: ${({ theme }) => theme.spacings[4]} 0;
`;

export const UserMenuItem = styled.button`
  ${({ theme }) => css`
    width: 100%;
    padding: ${theme.spacings[10]} ${theme.spacings[16]};
    display: flex;
    align-items: center;
    gap: ${theme.spacings[10]};
    border: 0;
    background: transparent;
    color: ${theme.colors.indigo800};
    font-family: ${theme.font.family.default};
    font-size: ${theme.font.sizes.sm};
    font-weight: ${theme.font.weights.medium};
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
    
    svg {
      color: ${theme.colors.indigo800};
      transition: color 0.15s ease;
    }

    &:not(:disabled):hover {
      background-color: ${theme.colors.gray100};
      color: ${theme.colors.blue600};
      
      svg {
        color: ${theme.colors.blue600};
      }
    }

    &:disabled {
      color: ${theme.colors.gray600};
      cursor: not-allowed;
      opacity: 0.55;

      svg {
        color: ${theme.colors.gray600};
      }
    }
  `}
`;

export const ContentEmail = styled.div`
  ${({ theme }) => css`
    width: 100%;
    min-width: 30rem;
    margin-top: ${theme.spacings[24]};

    > span {
      font-family: ${theme.font.family.default};
      font-weight: ${theme.font.weights.bold};
    }

    .contentLine {
      margin-top: ${theme.spacings[4]};

      display: flex;
      align-items: center;

      a {
        margin-left: ${theme.spacings[8]};

        color: ${theme.colors.blue600};

        &:hover {
          text-decoration: underline;
        }
      }
    }
  `}
`;
